// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file purchase_request/common.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { ItemType } from "../inventory/common_pb.js";

/**
 * @generated from enum com.neulink.pharmacy.RequestStatus
 */
export enum RequestStatus {
  /**
   * Default value, not specified
   *
   * @generated from enum value: REQUEST_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Purchase request is pending
   *
   * @generated from enum value: REQUEST_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * Purchase request has been approved
   *
   * @generated from enum value: REQUEST_STATUS_APPROVED = 2;
   */
  APPROVED = 2,

  /**
   * Purchase request has been rejected
   *
   * @generated from enum value: REQUEST_STATUS_REJECTED = 3;
   */
  REJECTED = 3,

  /**
   * Purchase request has been ordered
   *
   * @generated from enum value: REQUEST_STATUS_ORDERED = 4;
   */
  ORDERED = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(RequestStatus)
proto3.util.setEnumType(RequestStatus, "com.neulink.pharmacy.RequestStatus", [
  { no: 0, name: "REQUEST_STATUS_UNSPECIFIED" },
  { no: 1, name: "REQUEST_STATUS_PENDING" },
  { no: 2, name: "REQUEST_STATUS_APPROVED" },
  { no: 3, name: "REQUEST_STATUS_REJECTED" },
  { no: 4, name: "REQUEST_STATUS_ORDERED" },
]);

/**
 * @generated from message com.neulink.pharmacy.PurchaseRequestItem
 */
export class PurchaseRequestItem extends Message<PurchaseRequestItem> {
  /**
   * ID of the item being requested
   *
   * @generated from field: string master_id = 1;
   */
  masterId = "";

  /**
   * Quantity of the item requested
   *
   * @generated from field: int32 quantity = 2;
   */
  quantity = 0;

  /**
   * Optional notes for the item
   *
   * @generated from field: string notes = 3;
   */
  notes = "";

  /**
   * Type of the item (e.g., medication, equipment)
   *
   * @generated from field: com.neulink.pharmacy.ItemType item_type = 4;
   */
  itemType = ItemType.UNSPECIFIED;

  constructor(data?: PartialMessage<PurchaseRequestItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PurchaseRequestItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "master_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "item_type", kind: "enum", T: proto3.getEnumType(ItemType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PurchaseRequestItem {
    return new PurchaseRequestItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PurchaseRequestItem {
    return new PurchaseRequestItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PurchaseRequestItem {
    return new PurchaseRequestItem().fromJsonString(jsonString, options);
  }

  static equals(a: PurchaseRequestItem | PlainMessage<PurchaseRequestItem> | undefined, b: PurchaseRequestItem | PlainMessage<PurchaseRequestItem> | undefined): boolean {
    return proto3.util.equals(PurchaseRequestItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.PurchaseRequest
 */
export class PurchaseRequest extends Message<PurchaseRequest> {
  /**
   * Unique identifier for the purchase request
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Unique request number
   *
   * @generated from field: string request_number = 2;
   */
  requestNumber = "";

  /**
   * List of items in the purchase request
   *
   * @generated from field: repeated com.neulink.pharmacy.PurchaseRequestLineItem items = 3;
   */
  items: PurchaseRequestLineItem[] = [];

  /**
   * Optional notes for the purchase request
   *
   * @generated from field: string notes = 4;
   */
  notes = "";

  /**
   * Timestamp when the purchase request was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * Status of the purchase request (e.g., PENDING, APPROVED, REJECTED)
   *
   * @generated from field: com.neulink.pharmacy.RequestStatus status = 6;
   */
  status = RequestStatus.UNSPECIFIED;

  /**
   * Name of the stock point where the request is made
   *
   * @generated from field: string stock_point_name = 7;
   */
  stockPointName = "";

  constructor(data?: PartialMessage<PurchaseRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PurchaseRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "request_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "items", kind: "message", T: PurchaseRequestLineItem, repeated: true },
    { no: 4, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created_at", kind: "message", T: Timestamp },
    { no: 6, name: "status", kind: "enum", T: proto3.getEnumType(RequestStatus) },
    { no: 7, name: "stock_point_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PurchaseRequest {
    return new PurchaseRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PurchaseRequest {
    return new PurchaseRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PurchaseRequest {
    return new PurchaseRequest().fromJsonString(jsonString, options);
  }

  static equals(a: PurchaseRequest | PlainMessage<PurchaseRequest> | undefined, b: PurchaseRequest | PlainMessage<PurchaseRequest> | undefined): boolean {
    return proto3.util.equals(PurchaseRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.PurchaseRequestLineItem
 */
export class PurchaseRequestLineItem extends Message<PurchaseRequestLineItem> {
  /**
   * Unique identifier for the item
   *
   * @generated from field: string master_id = 1;
   */
  masterId = "";

  /**
   * Type of the item (e.g., medication, equipment)
   *
   * @generated from field: com.neulink.pharmacy.ItemType item_type = 2;
   */
  itemType = ItemType.UNSPECIFIED;

  /**
   * Quantity of the item requested
   *
   * @generated from field: float quantity = 3;
   */
  quantity = 0;

  /**
   * Optional notes for the item
   *
   * @generated from field: string notes = 4;
   */
  notes = "";

  /**
   * Name of the item
   *
   * @generated from field: string trade_name = 5;
   */
  tradeName = "";

  /**
   * Unit of measurement for the item
   *
   * @generated from field: int32 unit = 6;
   */
  unit = 0;

  /**
   * Type of unit (e.g., "mg", "ml", "pcs")
   *
   * @generated from field: string unit_type = 7;
   */
  unitType = "";

  constructor(data?: PartialMessage<PurchaseRequestLineItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PurchaseRequestLineItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "master_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "item_type", kind: "enum", T: proto3.getEnumType(ItemType) },
    { no: 3, name: "quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "trade_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "unit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "unit_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PurchaseRequestLineItem {
    return new PurchaseRequestLineItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PurchaseRequestLineItem {
    return new PurchaseRequestLineItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PurchaseRequestLineItem {
    return new PurchaseRequestLineItem().fromJsonString(jsonString, options);
  }

  static equals(a: PurchaseRequestLineItem | PlainMessage<PurchaseRequestLineItem> | undefined, b: PurchaseRequestLineItem | PlainMessage<PurchaseRequestLineItem> | undefined): boolean {
    return proto3.util.equals(PurchaseRequestLineItem, a, b);
  }
}

